export default {
	"dotia": {
		"name": "dotia",
		"basic": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9bb5d6",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"logo": "/static/img/brands/dotia/logo.svg",
		"logocolor": "/static/img/brands/dotia/logo-color.svg",
		"logodarkmode": "/static/img/brands/dotia/logo.svg",
		"logoSize": "small",
		"background": "/static/img/brands/dotia/background.jpg",
		"footer": {
			"textos": ["Dotia © 2021"]
		},

		"fonts": {
			"link": "family=Lato:400,500,700",
			"principal": "'Lato', sans-serif",
			"secundaria": "'Lato', sans-serif"
		},

		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},


		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,

		//REGISTRO DE LAS EMPRESAS
		"registroEmpresas": {
			"sede": {
				"visible": true,
				"required": true
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},


		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": true
			},
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,

		},



		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}
		},

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true

	},
	"uax": {
		"name": "uax",
		"dominio_produccion": "empleo.uax.es",
		"basic": {
			"default": "#004d91",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#eabd00",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9cb6d7",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/uax/logo.svg",
		"logocolor": "/static/img/brands/uax/logo-color.svg",
		"logodarkmode": "/static/img/brands/uax/logo.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/uax/background.jpg",
		"inMantenimiento": false,
		"analitycs": "UA-126614877-2",
		"emailContacto": "gaop@uax.es",
		"emailProblemas": "gaop@uax.es",
		"footer": {
			"textos": [
				"2021© Universidad Alfonso X el Sabio. La Universidad de la empresa",
				"Campus de Villanueva de la Cañada. Avd. Universidad, 1 Madrid. Teléfono 91 810 93 00"
			],
			"links": {
				"Aviso Legal": "https://gaop.uax.es/aviso-legal.html",
				"Política de privacidad": "https://gaop.uax.es/politica-privacidad.html",
				"Política de Cookies": "https://gaop.uax.es/politica-cookies.html"
			}
		},
		"fonts": {
			"link": "family=Indie+Flower|Luckiest+Guy",
			"principal": "'Arial', sans-serif",
			"secundaria": "'Arial', sans-serif"
		},
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},

		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,

		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true
		},

		//REGISTRO DE LAS EMPRESAS
		"registroEmpresas": {
			"sede": {
				"visible": true,
				"required": true
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": true
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": true,
				"dni": true,
			},
			
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"numeroDiasSemana": {
				"label": "Número de días por semana",
				"required": true
			},	
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}
		},

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": true,
				"editable": false
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"seleccionarEmailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": false
				},
				"2": {
					"visible": false,
					"editable": false
				}
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"hashelp" : 'alumnos',

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		//PROPUESTA DE PRACTICAS
		"instruccionesPropuestaPracticas": "/static/img/brands/uax/instrucciones-propuesta-de-practicas.pdf",
		"showPropuestaPracticas": true,
		"documentosPracticas": {
			"url": "https://www.miotroseguro.com/"
		},

		//REGISTRO DE LOS ALUMNOS
		"ownlogin": {
			"has": true,
			"textoEstudiantes": "Los estudiantes de UAX disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>",
			"textoEgresados": "Los egresados de UAX disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>"
		},
		 
		"checkMenuEducacion" : true,

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true
	},
	"comillas": {
		"name": "comillas",
		"basic": {
			"default": "#303338",
			"alternative": "#ffb81c",
			"fontAlternative": "#202020",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#ffb81c",
			"font": "#303338",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#97999b",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/comillas/logo.svg",
		"logocolor": "/static/img/brands/comillas/logo.svg",
		"logodarkmode": "/static/img/brands/comillas/logo-white.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/comillas/background.jpg",
		"emailContacto": "oia@comillas.edu",
		"emailProblemas": "oia@comillas.edu",
		"ownpopup_info": {
			"editar_personales": {
				"titulo": "Edición de datos personales",
				"texto": "Si alguno de los datos no editables no es correcto, por favor, accede a tu intranet para modificarlos."
			}
		},
		"footer": {
			"textos": [
				"© Universidad Pontificia Comillas",
				"C. Alberto Aguilera 23 Madrid-28015 - Tel.:<a href='tel:915422800'>(+34) 91 542 28 00</a> <a href='mailto:oia@comillas.edu'>oia@comillas.edu</a>"
			],
			"links": {
				"Aviso Legal": "https://www.comillas.edu/Documentos/Aviso_Legal.pdf",
				"Política de Cookies": "https://www.comillas.edu/es/politica-de-cookies",
				"Buzón de quejas, sugerencias y felicitaciones": "https://www.comillas.edu/es/unidad-de-calidad-y-prospectiva/sugerencias/buzon"
			}
		},
		"fonts": {
			"link": "family=Muli:300,400,500,700,800",
			"principal": "'Muli', sans-serif",
			"secundaria": "'Muli', sans-serif"
		},
		"ownstyles": "/static/img/brands/comillas/style.css",
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},



		//PROPUESTA DE PRACTICAS
		"instruccionesPropuestaPracticas": "",
		"showPropuestaPracticas": false,

		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": true,

		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Practicas', 'Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": true
			},
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,
		},

		//REGISTRO DE LA EMPRESA
		"requestStartUp": true,
		"requestTipoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionContactoEmpresa": true,
		"registroEmpresas": {
			"sede": {
				"visible": true,
				"required": true
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": true
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},


		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,
		"canEditPeriodoPracticas": true,

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": true,
				"editable": false
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": false
				},
				"2": {
					"visible": false,
					"editable": false
				}
			}
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		//DOCUMENTACIÓN DE EMPRESAS
		"haveDocumentosPracticas": true,

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true


	},
	"uc3m": {
		"name": "uc3m",
		"basic": {
			"default": "#001D83",
			"alternative": "#001D83",
			"fontAlternative": "#202020",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#001D83",
			"font": "#ffffff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#7E8EC1",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/uc3m/logo-b.svg",
		"logocolor": "/static/img/brands/uc3m/logo-color.svg",
		"logodarkmode": "/static/img/brands/uc3m/logo-b.svg",
		"logoencabezado": "/static/img/brands/uc3m/logo-color.svg",
		"logoSize": "big",
		"background": "/static/img/brands/uc3m/background.jpg",
		"emailContacto": "practicas@fund.uc3m.es",
		"emailProblemas": "practicas@fund.uc3m.es",
		"footer": {
			"textos": [
				"",
				""
			],
			"links": {
				"Aviso Legal": "https://www.fundacion.uc3m.es/aviso-legal/",
				"Política de Cookies": "https://www.fundacion.uc3m.es/politica-de-cookies/",
				"Política de protección de datos personales": "https://www.fundacion.uc3m.es/politica-de-privacidad/"
			}
		},
		"fonts": {
			"link": "family=Roboto:400,500,700",
			"principal": "'Roboto', sans-serif",
			"secundaria": "'Roboto', sans-serif"
		},
		"ownstyles": "/static/img/brands/uc3m/style.css",
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},

		"canCambiarPracticas": true,
		"busquedasGuardadas": true,
		"buscarPorInicioPracticas": true,

		//PROPUESTA DE PRÁCTICAS
		"showPropuestaPracticas": "isEmpresa",

		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": false,
		"canDuplicarOferta": true,
		"canDuplicarOfertaInvertida": true,
		"requestInfoSeleccionado": true,
		"hasOFertasTFM": true,
		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Objetivo formativo y contenido de las prácticas*"
				}
			},
			"otraFormacion": {
				"label": "Otra formación",
				"showIn": ['Empleo', 'Practicas'],
				"required": false
			},
			"opcionesPublicacion": {
				"showIn": ['Empleo', 'Practicas'],
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true


		},

		//REGISTRO DE LA EMPRESA
		"requestDireccionContactoEmpresa": true,
		"requestTipoEmpresa": true,
		"requestTipoContacto": true,
		"hideRequestFirmanteRegistro": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": true
			},
			"dni": {
				"visible": false,
				"required": false
			},
			'otrosector': {
				"visible": true,
				"required": true
			},
			"mensajepersonalizado": {
				"titulo": "¡Atención!",
				"mensaje": "Si va a seleccionar candidatos/as en prácticas, deberá firmar un convenio de colaboración educativa con UC3M. Puede solicitarlo desde el menú Documentación.",
				"to": "/login/empresas"
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},

		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"quitarCampoDiscapacidad": false,
		"campoDiscapacidadEditable": false,
		"canEditPeriodoPracticas": false,
		"personales": {
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false,
				"required": false
			},
			"password": false,
			"iban": {
				"visible": true,
				"editable": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true,
					"hide" : ['tipovia','piso','numero','puerta']
				},
				"2": {
					"visible": true,
					"editable": false,
					"hide" : ['tipovia','piso','numero','puerta']
				}
			},
			"direccionsimple": {
				"visible": false,
				"editable": false,
			}
		},


		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}
		},


		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Objetivo formativo/tareas",
				"required": true
			},
			"centropracticas": {
				"label": "Dirección de realización de las prácticas",
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": false,
				"telefono": true,
				"cargo": true
			},
			"direccion": false,
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,
		},

		"hasPresentacion": true,

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"enlace": {
				"editable": true,
				"validate": ''
			},
			"adjunto": {
				"editable": true,
				"validate": ''
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": true,
				"visible": true
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		"ownlogin": {
			"has": true,
			"textoEstudiantes": "Los estudiantes de UC3M disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.",
			"textoEgresados": "Los egresados de UC3M disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
		},
		"hasGuiasOrientacion": true,
		"hasEventos": true,

		//DOCUMENTACION
		"canSubirConvenios": true,
		"tituloConvenios" : "Convenios de Cooperación Educativa",
		"canCrearConvenios": true,
		"hasNotasFormativas" : true,
		"mensajeconveniogenerado": {
			"titulo": "Convenio Generado",
			"mensaje": "Por favor, revise el documento descargado.<br>En caso de ir a formalizar el documento con firma electrónica, para proceder a su formalización, es necesario que nos lo devuelvan con firma electrónica certificada haciendo clic en Subir Convenio Firmado. Si tiene cualquier duda puede contactarnos en practicas@fund.uc3m.es o en el 916249902.<br>En caso de formalización en papel, rogamos remitan en papel dos ejemplares originales impresos a una sola cara y firmados con firma manuscrita original en todas sus páginas a:<br>Fundación Universidad Carlos III<br>Orientación & Empleo<br>Edif. Sabatini<br>Despacho 20 D 09<br>Avda. de la Universidad, 30<br>28911 Leganés (Madrid).<br>La vigencia del Convenio será la de la firma de la Universidad, por favor no registren fecha en el documento.<br>Si tiene cualquier duda puede contactar en practicas@fund.uc3m.es o en 91 6249902",
			"to": "/documentacion"
		},
		"mensajeconveniosubido": {
			"titulo": "Convenio añadido correctamente",
			"mensaje": "Cuando la Universidad haya firmado el Convenio le enviaremos copia final. La tramitación de Anexos de prácticas requiere que se haya completado el proceso de firma por lo que hasta ese momento ningún alumno debe incorporarse en prácticas a la empresa. Si tiene cualquier duda puede contactar en practicas@fund.uc3m.es o en 916249902",
		},

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true
		

	},
	"uva": {
		"name": "uva",
		"basic": {
			"default": "#1e1e1e",
			"alternative": "#e20049",
			"fontAlternative": "#202020",
			"darkMode": "#ffffff"
		},
		"button": {
			"default": "#e20049",
			"font": "#ffffff",
			"darkMode": "#ffffff"
		},
		"soft_basic": {
			"default": "#8E8E8E",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/uva/logo-uva-white.png",
		"logocolor": "/static/img/brands/uva/logo-uva-black.png",
		"logoencabezado": "/static/img/brands/uva/logo-uva-black.png",
		"logodarkmode": "/static/img/brands/uva/logo-uva-white.png",
		"logoSize": "big",
		"background": "/static/img/brands/uva/background.jpg",
		"emailContacto": "funge@funge.uva.es",
		"emailProblemas": "gaop@uax.es",
		"analitycs": "UA-119874198-1",
		"dominio_produccion": "portal.uvaempleo.com",
		"portal_publico": "https://uvaempleo.com/",
		"ownpopup_info": {
			"uso_logo": {
				"titulo": "Autorizo el uso de la imagen de la empresa",
				"texto": "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en el portal de candidatos/as y en la web pública de empleo de FUNGE UVa. Aunque autorices ahora, cuando crees ofertas podrás configurar si quieres que se muestren o no, vinculados a esa oferta, los datos de tu empresa."
			}
		},
		"footer": {
			"textos": [
				"",
				""
			],
			"links": {
				"Aviso Legal": "https://funge.uva.es/aviso-legal/",
				"Política de Cookies": "https://funge.uva.es/politica-de-cookies/",
				"Política de privacidad": "https://funge.uva.es/proteccion-de-datos/"
			}
		},
		"fonts": {
			"link": "family=Open%20Sans:400,500,700",
			"principal": "'Open Sans', sans-serif",
			"secundaria": "'Open Sans', sans-serif"
		},
		"ownstyles": "/static/img/brands/uva/style.css",
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Titulados",
			"empresas": "Empresas"
		},


		"urlPortalTutores": "https://tutor.uvaempleo.com/",

		//PROPUESTA DE PRÁCTICAS
		"instruccionesPropuestaPracticasEmpresas": "/static/img/brands/uva/instrucciones-propuesta-de-practicas-UVa.pdf",
		"showPropuestaPracticas": 'isEmpresa',
		"requestProgramaPracticas": true,
		"hasProgramaPracticasActivo": true,
		"requestDatosFirmanteEnPropuesta": true,


		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": false,
		"canDuplicarOferta": true,
		"canDeleteOferta": true,
		"otrasRemuneracionesEnPracticas": true,
		"hasAnyoMaximoPromocion": true,
		"requestDatosFirmanteEnOferta": true,
		"requestDatosTutorEnOferta": true,
		"hideOpcionesCandidatos": true,
		"showMotivoRechazo": true,
		"poblacionesDomain": true,
		"tiempoDedicacionJornada": true,
		"HistoricoOfertas": true,
		"openTitulacionesSelector": true,
		"ocultarEmpresaEnOferta": true,
		"localidadesEnDominios": true,


		"camposOferta": {
			"tareas": {
				"showIn": ["Practicas"]
			},
			"otraRemuneracion": {
				"label": "Otros beneficios",
				"showIn": ['Practicas', 'Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": "Beca mensual",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"otraFormacion": {
				"label": "Otra formación",
				"showIn": ['Practicas']
			},
			"anyoMaximoPromocion": {
				"label": "Año de promoción límite",
				"showIn": ['Empleo']
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true
		},

		"camposPracticas": {
			"tareasDesglosadas": true,
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"otraRemuneracion": {
				"label": "Otros beneficios",
				"required": true
			},
			"ayudaEstudio": {
				"label": "Beca mensual",
				"disabledHide": true
			},
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas'],
			},
			"tutorEmpresa": {
				"cargo": true,
				"departamento": true,
				"telefono": true,
				"titulacion": false
			},
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,
		},

		//REGISTRO DE LA EMPRESA
		"requestDireccionContactoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionFacturacion": true,
		"requestTipoEmpresa": true,
		"requestTipoContacto": true,
		"hideRequestFirmanteRegistro": true,
		"requestPerfilSectorial": true,
		"checkDatosCompletosEmpresa": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": true
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},


		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"canEditDeLaUniversidad": true,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,
		"estanciaenextranjero": true,
		"hasDocumentacionLigadaProcesos": true,
		"quitarCampoNotaAcademicos": true,
		"formacionComplementaria": true,
		"competenciasProfesionales": true,
		"nivelesInformaticos": true,
		"BornActive": true,
		"popupDatosObligatorios": true,


		"academicos": {
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			},
			"certificado": {
				"editable": true
			},
			"horas": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nota": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}

		},



		"personales": {
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": true
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"nombre": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido1": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido2": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"password": true,
			"iban": {
				"visible": true,
				"editable": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"provinciaNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"lugarNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true
				},
				"2": {
					"visible": true,
					"editable": true
				}
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"idTipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idsubtipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idActividadProfesional": {
				"editable": true,
				"validate": 'required'
			},
			"enlace": {
				"editable": true,
				"validate": ''
			},
			"adjunto": {
				"editable": true,
				"validate": ''
			}
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		//REGISTRO DE LOS ALUMNOS
		"canRegistroAlumno": ['antiguos','estudiantes','alumnos'],
		"OneLoginForCandidatos": true,
		"hideSAML": true,
		"canBorrarCuenta": true,
		"checkDatosNecesariosEnLogin": true,
		"canRecoveryPass": true,
		"infoRGDP": true,

		//DOCUMENTACIÓN DE EMPRESAS
		"hasDocumentacionPrivadaCV": true,
		"canUploadDocEmpresas": true,
		"literalAnexosFirmados": "Documentos firmados para prácticas asignadas",
		"hideConveniosFirmados": true,
		"haveDocumentosPrograma": true,

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true

	},
	"uib": {
		"name": "uib",
		"basic": {
			"default": "#709194",
			"alternative": "#709194",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#709194",
			"font": "#ffffff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#BA4A40",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/uib/logo-login.svg",
		"logocolor": "/static/img/brands/uib/logo-color.svg",
		"logoLogin": "/static/img/brands/uib/logo-login.svg",
		"logoencabezado": "/static/img/brands/uib/logos-blanco.svg",
		"logodarkmode": "/static/img/brands/uib/logos-blanco.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/uib/background.jpg",
		"emailContacto": "doip@fueib.org",
		"emailProblemas": "doip@fueib.org",
		"analitycs": "UA-126614877-2",
		"footer": {
			"textos": [
				"",
				""
			],
			"links": {
				"Aviso Legal": "https://fueib.org/ca/aviso_legal",
				"Política de Cookies": "https://fueib.org/ca/aviso_cookies",
				"Política de protección datos personales": "https://fueib.org/ca/politica_de_privacidad"
			}
		},
		"fonts": {
			"link": false,
			"principal": "'uibsans', sans-serif",
			"secundaria": "'uibsans', sans-serif"
		},
		"ownstyles": "/static/img/brands/uib/style.css",
		"logintexts": {
			"antiguos": "Demandantes de empleo",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},
		"hideSAML" : false,

		//PROPUESTA DE PRÁCTICAS
		"showPropuestaPracticas": false,

		//SETEO DE OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": true,
		"requestDireccionContactoEmpresa": false,
		"requestDireccionFullContactoEmpresa": false,
		"requestTipoEmpresa": true,
		"canDuplicarOferta": true,
		"otrasRemuneracionesEnPracticas": true,
		"canDeleteOferta": true,
		"ocultarEmpresaEnOferta": true,
		"requestDatosRealizacionPractica": true,
		"filtradoenPracticas": true,
		"ofertasqueencajan" : true,
		"filtradoporetiquetas" : true,
		"checkIbanInPracticas" : true,
		"showMotivoRechazo": true,
		"checkIsla" : true,
		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": true
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": false
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"candidatoPreferido": {
				"label": "Candidato/a preferido",
				"showIn": ['Practicas']
			},
			"empresaDestino": {
				"showIn": ['Empleo']
			},
			"programasDeseables": {
				"showIn": ['Practicas', 'Empleo'],
			},
			"experienciadeseable": {
				"showIn": ['Empleo'],
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"creditos": {
				"showIn": ['Practicas'],
			},
			"canIdiomaDeseable": true,
			"requisitosfromcv": false,
			"paraPerfilNoUniversitario": {
				"showIn": ['Empleo'],
			},
			"paraEstudiantesUltimoCurso": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"observacionespublicas": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": true
			},
			"ocultarDatosEmpresa": true

		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
	
			"tutorEmpresa": {
				"titulacion": true
			},
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['']
			},
			"okDeEmpresaParaValidar": {
				"label": "Enviar oferta para su revisión y, en su caso, publicación por DOIP",
				"showIn": ['Practicas', 'Empleo']
			},
			"departamento": true,
			"solicitudParaCentroEducativo": true,
			"tipoPracticaCurriExtracurri": true,
		},

		//REGISTRO DE LAS EMPRESAS
		"requestTipoContacto": true,
		"requestidiomaComunicacionContacto": true,

		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": true
			},
			"iban": {
				"visible": true,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
			'numeroempleados': {
				"visible": true,
				"required": false
			},
			"sector": {
				"visible": true,
				"required": true
			},
			"centroTrabajoAdicional" : {
				"visible": true,
				"required": true
			},
			"tagLiteralEmailEmpresa": "login.email",
			"tagLiteralTelefonoEmpresa": "login.telefono_1"
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": true,
				"editar": true
			}
		},

		"hidesedeperfil" : true,
		"hideEmailMiEmpresa" : true,


		"canRegistroAlumno": ['antiguos'],

		"canRecoveryPass" : true,

		"textoRecoveryPass" : "Si eres estudiante o egresado de Universitat de les Illes Balears debes acudir a <a href='https://sso.uib.es/cas/login' target='_blank'>UIBdigital</a> para restablecer o recuperar tu contraseña.",
		"logoutSSO" :"https://sso.uib.es/cas/prelogout",

		//CV DEL CANDIDATO
		"datosProfesionales": true,
		"otrosIntereses": true,
		"quitarCampoDiscapacidad": false,
		"campoDiscapacidadEditable": false,
		"canUploadDocEmpresas": false,
		"hasDocumentacionPrivadaCV": true,
		"hasDocumentacionLigadaProcesos": true,
		"competenciasProfesionales": true,
		"testCompetenciasProfesionales" : "/encuestas/encuesta-competencias-transversales",
		"validadoporellos" : true,
		"textvalidadoporellos" : "Alumno validado por DOIP UIB",
		"ocultarAcademicos" : true,
		"personales": { 
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"tipoDocumentoIdentidad": {
				"visible": false,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"password": true,
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"idIdiomaPreferido": {
				"visible": true,
				"editable": true
			},
			"direcciones": {
				"1": {
					"visible": false,
					"editable": false,
					"notas" : false
				},
				"2": {
					"visible": true,
					"editable": true,
					"notas" : true,
					"hide" : ['tipovia','piso','numero','puerta']
				}
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"idPaisSegundaNacionalidad": {
				"visible": true,
				"editable": true,
				"required": false
			},
			"aceptaComunicacionesOrientacion": {
				"visible": true,
				"editable": true,
				"required": false
			},
			"direccionsimple": {
				"visible": false,
				"editable": false,
				
			},
			"iban": {
				"visible": true,
				"editable": true
			},
		},

		"hasPresentacion": true,


		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": false
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": true,
				"visible": true
			},
			"minimaRetribucion": {
				"editable": true,
				"visible": true
			},
			"trabajandoActualmente": {
				"editable": true,
			 	"visible": true
			},
			"aniosExperiencia": {
				"editable": true,
				"visible": true
			}
		},

		"custommessage_busquedaactiva" : 'busquedaactivaempleo_uib',

		"interes" : {
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadViajar" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadjornadas" :{
				"editable": true,
				"visible": true
			},
			"carnetMoto" :{
				"editable": true,
				"visible": true
			},
			"motoPropia" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": true,
			"descripcionOferta": true,
			"fechaCaducidad": false
		},

		//nueva oferta
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"mostrarSucursalOferta": false,
		"mostrarTitulacionesDeseables":true,
		"mostrarEstudiosObligatorios": true
	},
	"nebrija": {
		"name": "nebrija",
		"basic": {
			"default": "#C31632",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#C31632",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9cb6d7",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/nebrija/logo.svg",
		"logocolor": "/static/img/brands/nebrija/logo-negro.svg",
		"logoencabezado": "/static/img/brands/nebrija/logo-negro.svg",
		"logodarkmode": "/static/img/brands/nebrija/logo.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/nebrija/background.jpg",
		"inMantenimiento": false,
		"emailContacto": "nebrijaprofesional@nebrija.es",
		"emailProblemas": "nebrijaprofesional@nebrija.es",
		"ownpopup_info": {
			"limitaciones_fichero": {
				"titulo": "Ficheros permitidos",
				"texto": "¡Atención! Los ficheros no pueden superar los 15Mb. Las extensiones permitidas son las siguientes: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff y tif."
			}
		},
		"footer": {
			"textos": [
				""
			],
			"links": {
				"Aviso Legal": "https://www.nebrija.com/general/legal.php",
				"Política de privacidad": "https://www.nebrija.com/general/politica-privacidad.php",
				"Política de Cookies": "https://www.nebrija.com/general/politica-cookies.php"
			}
		},
		"fonts": {
			"link": "family=Indie+Flower|Luckiest+Guy",
			"principal": "'Arial', sans-serif",
			"secundaria": "'Arial', sans-serif"
		},
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},

		//CV DEL CANDIDATO
		"datosProfesionales": false,
		"otrosIntereses": false,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,
		"competencias": true,
		"tamanioMaxAdjuntosEstudianteMB": 15,

		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": false
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": false
			},
			"filtroCustom": ['areaFuncional', 'tiposFormacion', 'tituloPrograma'],
			"ocultarDatosEmpresa": false
		},

		//REGISTRO DE LAS EMPRESAS

		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": false
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": false,
				"required": false
			},
			"email": {
				"visible": true,
				"required": true
			},
			"aniosforo": {
				"visible": true,
				"required": true
			},
			"nombreFiscal": {
				"visible": true,
				"required": true
			},
			"firmante": {
				"visible": true,
				"required": true
			},
			"antiguoAlumno": {
				"visible": true,
				"required": false
			},
			"sector": {
				"visible": true,
				"required": false
			},
			"centroTrabajoAdicional" : {
				"visible": false,
				"required": false
			},
			"hidetipoSociedad" : true,
			"logoRequired" :true,
			"tagLiteralEmailEmpresa": "login.email_generico_empresa",
			"tagLiteralTelefonoEmpresa": "login.telefono_generico_empresa",
			"maxLengthDescripcion": 1300
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": false,
				"editar": false
			}
		},

		"hidedniperfil" : true,
		"hidesedeperfil" : true,

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": false,
				"dni": false,
				"cargo": true,
				"departamento": true
			},
			
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"numeroDiasSemana": {
				"label": "Número de días por semana",
				"required": true
			},
			"departamento": false,
			"solicitudParaCentroEducativo": false,
			"tipoPracticaCurriExtracurri": false,
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": true
			},
			"titulo": "Formación"
		},

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": true,
				"editable": false
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"seleccionarEmailComunicaciones": {
				"visible": false,
				"editable": false
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": false
				},
				"2": {
					"visible": false,
					"editable": false
				}
			},
			"linkedin":{
				"visible": true,
				"editable": true
			},
			"direccionsimple": {
				"visible": true,
				"editable": false,
			},
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": false,
				"visible": false
			},
			"minimaRetribucion": {
				"editable": false,
				"visible": false
			},
			"trabajandoActualmente": {
				"editable": false,
			 	"visible": false
			},
			"aniosExperiencia": {
				"editable": false,
				"visible": false
			}
		},

		"interes" : {
			"title": "Otros datos de interés",
			"busquedaActivaEmpleo" :{
				"editable": false,
				"visible": false
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": false,
				"visible": false
			},
			"disponibilidadViajar" :{
				"editable": false,
				"visible": false
			},
			"observaciones" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": false,
			"descripcionOferta": false,
			"fechaCaducidad": true
		},

		"ownlogin": {
			"has": true,
			"textoEstudiantes": "<h3>Bienvenido al Portal de Prácticas Formativas<h2><br><p style='color:black;'>Los estudiantes de Universidad Nebrija disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la universidad.</p><br><p style='color:black;'>Accede a continuación para identificarte.</p>",
			"textoEgresados": ""
		},

		//PROPUESTA DE PRACTICAS
		"showPropuestaPracticas": true,

		//REGISTRO DE LOS ALUMNOS
		"OneLoginForCandidatos": true,
		"editaContactoPrincipal" : true,
		"tieneCentrosTrabajo": true,

		//nueva oferta
		"titulacionesRequeridasOfertaByDropdown": true,
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"localidadOfertaByDropdown": true,
		"mostrarSucursalOferta": false,
		"poblacionesDomain": true,
		"mostrarTitulacionesDeseables":false,
		"mostrarEstudiosObligatorios": false,
		"labelEstudiosObligatorios": "Estudios del candidato",

		//direccion por defecto
		"idPaisPorDefectoEmpresa": 1,
		"idProvinciaPorDefectoEmpresa": 28,
		"idLocalidadPorDefectoEmpresa": 3459,

		"logoutSSO": {
			"localhost:8080": "https://fspre.nebrija.es/adfs/ls/?wa=wsignout1.0",
			"portal-nebrija.dev.doubledot.es": "https://fspre.nebrija.es/adfs/ls/?wa=wsignout1.0",
			"nebrijaprofesional.nebrija.es": "https://fs.nebrija.es/adfs/ls/?wa=wsignout1.0"
		}
	},
	"educaedtech": {
		"name": "educaedtech",
		"basic": {
			"default": "#000000",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9bb5d6",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasfavicon": "true",
		"logo": "/static/img/brands/educaedtech/logo-b.svg",
		"logocolor": "/static/img/brands/educaedtech/logo-color.svg",
		"logodarkmode": "/static/img/brands/educaedtech/logo-b.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/educaedtech/background.png",
		"emailContacto": "formacion@euroinnova.com",
		"emailProblemas": "formacion@euroinnova.com",
		"footer": {
			"links": {
				"Política de privacidad": "https://www.euroinnova.com/politica-de-privacidad",
				"Aviso Legal": "https://www.euroinnova.com/aviso-legal",
				"Política de Cookies": "https://www.euroinnova.com/politica-de-cookies"
			}
		},
		"fonts": {
			"link": "family=Indie+Flower|Luckiest+Guy",
			"principal": "'Arial', sans-serif",
			"secundaria": "'Arial', sans-serif"
		},
		"logintexts": {
			"antiguos": "Alumni",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas"
		},

		//CV DEL CANDIDATO
		"datosProfesionales": false,
		"otrosIntereses": false,
		"quitarCampoDiscapacidad": true,
		"campoDiscapacidadEditable": false,
		"competencias": true,
		"tamanioMaxAdjuntosEstudianteMB": 15,
		"popupDatosObligatorios": true,

		//SETEO DE LAS OFERTAS
		"CVRequired": true,

		"camposOferta": {
			"otraRemuneracion": {
				"label": "Otra remuneración",
				"showIn": ['Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": false
			},
			"descripcion": {
				"label": {
					"Empleo": "Descripción del puesto*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			"niveles": {
				"show": false
			},
			"filtroCustom": ['areaFuncional', 'tiposFormacion', 'tituloPrograma','modalidad'],
			"ocultarDatosEmpresa": false
		},

		//REGISTRO DE LAS EMPRESAS

		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"descripcionEmpresa": {
				"visible": true,
				"required": false
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": false,
				"required": false
			},
			"email": {
				"visible": true,
				"required": true
			},
			"aniosforo": {
				"visible": false,
				"required": false
			},
			"nombreFiscal": {
				"visible": true,
				"required": true
			},
			"firmante": {
				"visible": true,
				"required": true
			},
			"antiguoAlumno": {
				"visible": true,
				"required": false
			},
			"sector": {
				"visible": true,
				"required": false
			},
			"centroTrabajoAdicional" : {
				"visible": false,
				"required": false
			},
			"hidetipoSociedad" : true,
			"logoRequired" :true,
			"tagLiteralEmailEmpresa": "login.email_generico_empresa",
			"tagLiteralTelefonoEmpresa": "login.telefono_generico_empresa",
			"maxLengthDescripcion": 1300
		},

		"miEmpresa": {
			"centroTrabajo": {
				"annadir": false,
				"editar": false
			}
		},

		"hidedniperfil" : true,
		"hidesedeperfil" : true,

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": false,
				"dni": false,
				"cargo": true,
				"departamento": true
			},
			
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": ['Practicas']
			},
			"numeroDiasSemana": {
				"label": "Número de días por semana",
				"required": true
			},
			"departamento": false,
			"solicitudParaCentroEducativo": false,
			"tipoPracticaCurriExtracurri": false,
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"formacionAcademica":{
				"visible": true
			},
			"titulo": "Formación"
		},

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": true,
				"editable": false
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"seleccionarEmailComunicaciones": {
				"visible": false,
				"editable": false
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": false,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": false
				},
				"2": {
					"visible": false,
					"editable": false
				}
			},
			"linkedin":{
				"visible": true,
				"editable": true
			},
			"direccionsimple": {
				"visible": true,
				"editable": true,
				"required": true
			},
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			},
			"permisoTrabajoUE": {
				"editable": false,
				"visible": false
			},
			"minimaRetribucion": {
				"editable": false,
				"visible": false
			},
			"trabajandoActualmente": {
				"editable": false,
			 	"visible": false
			},
			"aniosExperiencia": {
				"editable": false,
				"visible": false
			}
		},

		"interes" : {
			"title": "Otros datos de interés",
			"busquedaActivaEmpleo" :{
				"editable": true,
				"visible": true
			},
			"disponibilidadTrabajarExtranjero" :{
				"editable": false,
				"visible": false
			},
			"disponibilidadViajar" :{
				"editable": false,
				"visible": false
			},
			"observaciones" :{
				"editable": true,
				"visible": true
			}
		},

		"listadoOfertas": {
			"mostrarInscribirDesinscribir": false,
			"descripcionOferta": false,
			"fechaCaducidad": true
		},

		// "ownlogin": {
		// 	"has": false,
		// 	"textoEstudiantes": "<h3>Bienvenido al Portal de Prácticas Formativas<h2><br><p style='color:black;'>Los estudiantes de Universidad Nebrija disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la universidad.</p><br><p style='color:black;'>Accede a continuación para identificarte.</p>",
		// 	"textoEgresados": ""
		// },

		//PROPUESTA DE PRACTICAS
		"showPropuestaPracticas": true,

		//REGISTRO DE LOS ALUMNOS
		"OneLoginForCandidatos": true,
		"editaContactoPrincipal" : true,
		"tieneCentrosTrabajo": true,

		//nueva oferta
		"titulacionesRequeridasOfertaByDropdown": false,
		"mostrarPaisOferta": true,
		"mostrarProvinciaOferta": true,
		"mostrarPoblacionOferta": true,
		"datosLocalidadOfertaEditables": true,
		"localidadOfertaByDropdown": true,
		"mostrarSucursalOferta": false,
		"poblacionesDomain": true,
		"mostrarTitulacionesDeseables":false,
		"mostrarEstudiosObligatorios": false,
		"labelEstudiosObligatorios": "Estudios del candidato",

		//direccion por defecto
		"idPaisPorDefectoEmpresa": 1,
		"idProvinciaPorDefectoEmpresa": 28,
		"idLocalidadPorDefectoEmpresa": 3459,

		"logoutSSO": "https://mylxp.euroinnova.com"
	},
}


// WEBPACK FOOTER //
// ./src/brands/brands.js